module.exports = __webpack_public_path__ + "static/people_pop6-d62566bec728d439c85a55797b8e28e7.png";